import { createFileRoute } from "@tanstack/react-router";

import { RoleGuard } from "@/components/shared/guards/role-guard";
import { ScheduledJobsPage } from "@/features/platform-admin";

function ScheduledJobsRoute() {
  return (
    <RoleGuard allowedRoles={["platform_admin"]}>
      <ScheduledJobsPage />
    </RoleGuard>
  );
}

export const Route = createFileRoute("/platform-admin/scheduled-jobs")({
  component: ScheduledJobsRoute,
});
